// extracted by mini-css-extract-plugin
export default {"modalContainer":"PremediacionModal_modalContainer__x0-ur","modal":"PremediacionModal_modal__bhWWJ","closeModal":"PremediacionModal_closeModal__uXNZP"};